import { TrendUp } from "@phosphor-icons/react";
import React from "react";

export default function AccountDetail({ name, amount, percent = 0 }) {
  return (
    <span>
      <p>{name}</p>
      <p className="font-bold text-2xl mt-2">${amount}</p>
      {percent === 0 ? (
        ""
      ) : (
        <p className="mt-2 bg-green-600 rounded-full lg:p-1  text-center flex justify-center items-center gap-2 w-fit p-[9px]">
         <TrendUp size={26}  /> {percent}
        </p>
      )}
    </span>
  );
}
